"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eSanctionsChecksFilterValues = exports.eSanctionsChecksFilterTypes = void 0;
var eSanctionsChecksFilterTypes;
(function (eSanctionsChecksFilterTypes) {
    eSanctionsChecksFilterTypes["CHECK"] = "check";
    eSanctionsChecksFilterTypes["NAME"] = "name";
})(eSanctionsChecksFilterTypes = exports.eSanctionsChecksFilterTypes || (exports.eSanctionsChecksFilterTypes = {}));
var eSanctionsChecksFilterValues;
(function (eSanctionsChecksFilterValues) {
    eSanctionsChecksFilterValues["PASS"] = "pass";
    eSanctionsChecksFilterValues["fail"] = "fail";
    eSanctionsChecksFilterValues["PASS_OVERRIDE"] = "pass-override";
    eSanctionsChecksFilterValues["FAIL_PASS_OVERRIDE"] = "fail-override";
    eSanctionsChecksFilterValues["PASS_DOWN"] = "pass-down";
    eSanctionsChecksFilterValues["FAIL_DOWN"] = "fail-down";
})(eSanctionsChecksFilterValues = exports.eSanctionsChecksFilterValues || (exports.eSanctionsChecksFilterValues = {}));
//# sourceMappingURL=index.js.map